<template>
	<el-tabs id="userinfoList" value="first" type="border-card">
		<el-tab-pane name="first" :label="$t('taskInfo')">
			<el-row>
				<el-col :xs="24">
          <el-form :model="taskForm" :rules="rules" ref="taskForm" label-width="200px">
					  <el-card >
              <el-row>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectName1')" prop="projectId">
                    <el-select v-model="taskForm.projectId" disabled >
                      <el-option v-for="item in ProjectList" :key="item.projectNumber" :label="item.projectName" :value="item.projectNumber"></el-option>
                    </el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskType1')" prop="taskType">
                    <el-select v-model="taskForm.taskType" disabled >
											<el-option v-for="item in TaskTypeList" :key="item.sysDesc" :label="item.sysValue" :value="item.sysDesc"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskName1')" prop="taskName">
										<el-input v-model="taskForm.taskName" disabled :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('serviceBom1')" >
                    <el-select v-model="taskForm.serviceBom" clearable filterable remote :remote-method="remoteBom" v-el-select-loadmore="loadMore(rangeNumber)"
                        :disabled="!(taskForm.taskType === 'POC' || (taskForm.createUser == 'sync' && businessCategory=='CD' && serviceBomDisabled) )" @change="changeBom">
                      <el-option v-for="(item, index) in ServiceBomList.slice(0, rangeNumber)" :key="index" :label="item.serviceBom" :value="item.serviceBom"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('bomDescription1')" >
                    <el-input v-model="taskForm.bomDescription" clearable :disabled="taskForm.createUser == 'sync'||businessCategory=='CD'" :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskOwner1')" prop="taskOwner">
                    <el-select v-model="taskForm.taskOwner" clearable filterable remote :remote-method="remoteMethod" v-el-select-loadmore="loadMore(rangeNumber)">
                      <el-option v-for="(item, index) in TaskOwnerList.slice(0, rangeNumber)" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
                    </el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskStatus1')" prop="taskStatus" >
                    <el-select v-model="taskForm.taskStatus" clearable>
											<el-option v-for="item in StatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
              </el-row>
              <!-- <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceContent1')" prop="serviceContent" >
                    <el-select v-model="taskForm.serviceContent" clearable >
											<el-option v-for="item in ServiceContentList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
                    <el-input v-model="taskForm.serviceContent" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceQuantity1')" >
										<el-input v-model="taskForm.serviceQuantity" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
              </el-row> -->
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('financialAttributes1')" prop="financialAttributes">
                    <el-select filterable v-model="taskForm.financialAttributes" disabled>
											<el-option v-for="item in FinancialAttributesList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('planLabourHour1')" >
										<el-input v-model="taskForm.planLabourHour" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('revenueConfirmationMethod1')" >
                    <el-select filterable v-model="taskForm.revenueConfirmationMethod" clearable>
											<el-option v-for="item in RevenueConfirmationMethodList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskSubcontract1')" prop="subcontract">
                    <el-select filterable v-model="taskForm.subcontract" clearable>
											<el-option v-for="item in SubcontractList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<!-- <el-row>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('hardwareProductLine1')" prop="hardwareProductLine">
										<el-select filterable v-model="taskForm.hardwareProductLine" clearable>
											<el-option v-for="item in HardwareProductLineList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceProductLine1')" prop="serviceProductLine">
                    <el-select filterable v-model="taskForm.serviceProductLine" clearable>
											<el-option v-for="item in ServiceProductLineList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row> -->
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskStartDate1')" prop="taskStartDate">
										<el-date-picker v-model="taskForm.taskStartDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskEndDate1')" prop="taskEndDate">
										<el-date-picker v-model="taskForm.taskEndDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
              </el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryArea1')" prop="deliveryArea">
                    <el-input v-model="taskForm.deliveryArea" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskAmountWithTax1')" >
                    <el-input v-model="taskForm.amountWithTax" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
                <!-- <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryLabourHour1')" prop="deliveryLabourHour">
                    <el-input v-model="taskForm.deliveryLabourHour" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col> -->
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('revenueConfirmationAmount1')" >
										<el-input v-model="taskForm.revenueConfirmationAmount" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('revenueConfirmationStatus1')">
										<el-input v-model="taskForm.revenueConfirmationStatus" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
							</el-row>
							<!-- <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryFinishDate1')" prop="deliveryFinishDate"  >
                    <el-date-picker v-model="taskForm.deliveryFinishDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
							</el-row> -->
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subcontractNo1')" >
                    <el-input v-model="taskForm.subcontractNo" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskSubcontractor1')" >
                    <el-input v-model="taskForm.subcontractor" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <!-- <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskCompletion1')" >
                    <el-select v-model="taskForm.taskCompletion" clearable>
											<el-option v-for="item in TaskCompletionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col> -->
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('taskReport1')"  >
                    <el-upload action="" :accept="acceptFileType" :before-upload="beforeUpload" 
                      :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" :auto-upload="true" >
                      <el-button slot="trigger" size="small" type="primary">{{$t('upload')}}</el-button>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('serviceDuration1')" >
										<el-input v-model="taskForm.serviceDuration" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col style="margin-top: 10px; text-align: center;" :xs="24" :md="24">
                  <el-button type="primary" @click="submitForm('taskForm')">{{$t('save')}}</el-button>
                  <el-button type="primary" size="medium" @click="returnList">{{$t('return')}}</el-button>
                </el-col>
              </el-row>
            </el-card>
          </el-form>
				</el-col>
			</el-row>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
    import {_debounce} from '@/utils/selectAPI'
    import * as validate from '@/utils/validate'
    export default {
        created () {
          this.getProjectList();
          this.getServiceBomList();
          this.getTaskData();
          this.getTaskTypeList();
        },
        data () {
          var checkDate = (rule, value, callback) => {
            if(this.taskForm.taskStartDate != null && this.taskForm.taskEndDate !=  null){
              if(this.taskForm.taskStartDate >= this.taskForm.taskEndDate ){
                return callback(new Error('The end date must be later than start date'));
              }else if(this.taskForm.taskEndDate > this.pjEndDate){
                return callback(new Error('The task end date must be earlier than project end date'));
              }
            }
            callback();
          };
          var checkFinishDate  = (rule, value, callback) => {
            if(this.taskForm.taskStartDate != null){
              if(this.taskForm.taskStartDate >= value ){
                return callback(new Error('The finish date must be later than start date'));
              }
            }
            callback();
          };
          var checkHours = (rule, value, callback) => {
            if(value != null && value != ""){
              let reg = /^\d+(\.\d{0,2})?$/;
              if(!reg.test(value)){
                return callback(new Error('Please enter integer or decimal to two places'));
              }else if(value < 0.01 || value > 9999){
                return callback(new Error('Please enter 0.01--9999.00'));
              }
            }
            callback();
          };
          return {
            rangeNumber: 10,
            taskForm: {
              projectId:null,
              taskName:null,
              taskOwner:null,
              taskStatus:null,
              taskType:null,
              serviceBom:null,
              bomDescription:null,
              financialAttributes:null,
              subcontract:null,
              subcontractor:null,
              revenueConfirmationMethod:null,
              hardwareProductLine:null,
              serviceProductLine:null,
              serviceDuration:null,
              taskStartDate:null,
              taskEndDate:null,
              deliveryArea:null,
              deliveryLabourHour:null,
              revenueConfirmationAmount:null,
              revenueConfirmationStatus:null,
              amountWithTax:null,
              deliveryFinishDate:null,
              remasubcontractNork:null,
              taskCompletion:null,
              taskReport:null,
            },
            serviceBomDisabled:false,
            reportArr:[],
            fileList:[],
            acceptFileType:'.bpm,.gif,.jpg,.jpeg,.png,.pdf,.xls,.xlsx,.doc,.docx',
            pjEndDate:null,
            businessCategory:null,
            TaskOwnerList:[],
            ProjectList:[],
            PJList:[],
            ServiceBomList:[],
            SBomList:[],
            StatusList:[
              { value: 'ToDelivered',label: 'Waiting for Delivery'},
              { value: 'Delivered',label: 'Delivering'},
              { value: 'DeliveryCompleted',label: 'Fully Delivered'},
            ],
            TaskTypeList:[],
            FinancialAttributesList:[
              { value: 'Warranty',label: 'Warranty'},
              { value: 'ServiceCost',label: 'Service Cost'},
              { value: 'ExchangeFee',label: 'Market Support Expense'},
              { value: 'PlatformFee',label: 'Platform Expense'},
              { value: 'MarketingFee',label: 'Service Marketing Expense'},
            ],
            RevenueConfirmationMethodList:[
              { value: 'PS-CTC',label: 'PS-CTC'},
              { value: 'PS-COM',label: 'PS-COM'},
              { value: 'PS-PER',label: 'PS-PER'},
              { value: 'PS-NRA',label: 'PS-NRA'},
            ],
            SubcontractList:[
              { value: 'Yes',label: 'Yes'},
              { value: 'No',label: 'No'},
            ],
            HardwareProductLineList:[
              { value: '1',label: '待定'},
            ],
            ServiceProductLineList:[
              { value: '1',label: '待定'},
            ],
            TaskCompletionList:[
              { value: 'uncomplete',label: '未完成'},
              { value: 'completed',label: '完成'},
            ],
            rules: {
              projectId: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              taskName: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              taskStatus: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              taskOwner: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              taskType: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              serviceContent: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              serviceBom: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              bomDescription: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              financialAttributes: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              taskStartDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              taskEndDate: [
                { required: true, message:'Please select date', trigger: 'change' },
                { validator: checkDate, trigger: 'change'}
              ],
              deliveryArea: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              deliveryLabourHour: [
                { validator: checkHours, trigger: 'blur' }
              ],
              deliveryFinishDate: [
                { validator: checkFinishDate, trigger: 'change'}
              ],
              subcontract: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
            }
          }
        },
        methods: {
          getTaskTypeList(){
            let url = `${this.$store.state.islhurl}keyValue/getSelectData`
            let pm = {
              sysKey: 'TaskType',
              delFlg: '0',
            }
            this._post(url,pm).then(
              res =>{
                this.TaskTypeList = res.data;
              }
            )
          },
          getServiceBomList(){
            let url =`${this.$store.state.islhurl}serviceBom/getSelectData`;
            this._post(url).then(
              res => {   
                this.SBomList = res.data;
                this.ServiceBomList = res.data;
              }
            )
          },
          getProjectList(){
            let url =`${this.$store.state.islhurl}project/getSelectProjectToDetail`;
            this._get(url).then(
              res => {   
                this.PJList = res.data;
              }
            )
          },
          changeBom(serviceBom){
            let bomInfo = this.ServiceBomList.find(item => {
              return item.serviceBom === serviceBom;
            })
            if(bomInfo != null){
              let bomdesc = bomInfo.bomEnDescribe==null?bomInfo.serviceDescribe:bomInfo.bomEnDescribe;
              this.taskForm.bomDescription = bomdesc;
            }
          },
          //回显数据
          getTaskData(){
            let url = `${this.$store.state.islhurl}task/getInfo`
            let pm = {
              id: this.$route.params.id,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                //先加载下拉选项
                setTimeout(() => {
                  this.filterUserCode(res.task.taskOwner);
                }, 1500);
                setTimeout(() => {
                  this.filterProjectCode(res.task.projectId);
                  this.getBusinessCategory(res.task.projectId);
                }, 800);
                //再进行赋值
                this.taskForm = res.task;
                //若有附件，显示附件名称
                if(res.task.taskReport != null && res.task.taskReport != 0){
                  let reportAy = res.task.taskReport.split(",");
                  reportAy.forEach(item => {
                    let params = {
                      id: item,
                      islhToken : sessionStorage.getItem('islhtoken'),
                    }
                    let url =`${this.$store.state.islhurl}attachment/getInfo`;
                    this._post(url, params).then(
                      res =>{
                        this.fileList.push({name: res.attachment.fileName, url: res.attachment.fileAliasName});
                        this.reportArr.push({aid: res.attachment.id, fileurl: res.attachment.fileAliasName});
                      }
                    )
                  });
                }
              }
            )
          },
          getBusinessCategory(projectId){
            let projectInfo = this.PJList.find(item => {
              return item.projectNumber === projectId;
            })
            if(projectInfo != null){
              this.businessCategory = projectInfo.businessCategory;
              this.pjEndDate = projectInfo.projectEndDate;
            }
          },
          submitForm(formName) {
            this.$refs[formName].validate((pvalid) => {
              if (pvalid) {
                console.log('success submit')
                this.editInfo();
              } else {
                console.log('error submit!!');
                return false;
              } 
            });
          },
          editInfo(){
            if(this.reportArr != null && this.reportArr.length > 0){
              let attachmentArr = [];
              this.reportArr.forEach(item => {
                attachmentArr.push(item.aid);
              });
              this.taskForm.taskReport = attachmentArr.join(",");
            }
            let params = {
              taskId:this.$route.params.id,
              task:this.taskForm,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            // console.log(params);
            let url = `${this.$store.state.islhurl}task/editInfo`
            this._post(url,params).then(
              res => {
                if(res=="200"){
                  // this.$router.push({path:'/task/list'})
                  let pm = {toTask: 'N'}
                  this.$router.push({name:'task',params:pm});
                  this.$Message.success('Save successful' )
                }else{
                  this.$message.error(res);
                }
              }
            )
          },
          beforeUpload(file){
            this.downloadLoading = this.$loading({
              lock:true,
              text:'Data is importing...',
              spinner:'el-icon-loading',
              background:'rgba(0,0,0,0.7)'
            });
            let fd = new FormData();
            fd.append('fileInput',file);
            fd.append('source',"Task");
            fd.append('islhToken',sessionStorage.getItem("islhtoken"));
            let url = `${this.$store.state.islhurl}upload`
            this._post(url,fd).then(
              res =>{
                this.downloadLoading.close();
                if(res.code == '200'){
                  this.fileList.push({name: res.fileName, url: res.fileAliasName});
                  this.reportArr.push({aid: res.attachmentId, fileurl: res.fileAliasName});
                  this.$message.success('File import successful！');
                }else{
                  this.$message({type:'error', showClose:true, duration:10000, message:res});
                }
              }
            ).catch(error=> {
              this.downloadLoading.close();
              this.$message({type:'error', showClose:true, duration:10000, message:'Operation failed！error:'+error});
            })
          },
          handlePreview(file){
            let url =`${this.$store.state.islhurl}download?fileAliasName=${file.url}&fileName=${file.name}`
            window.open(url);
          },
          handleRemove(file){
            if (file && file.status === "success") {
              let attachmentId = null;
              this.reportArr.forEach(item => {
                if (item.fileurl === file.url) {
                  attachmentId = item.aid;
                  this.reportArr.splice(item, 1);
                }
              });
              let params = {
                id: attachmentId,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
              let url =`${this.$store.state.islhurl}attachment/deleteInfo`;
              this._post(url, params).then(
                res => {
                  this.fileList.forEach(item => {
                    if (item.url === file.url) {
                      this.fileList.splice(item, 1);
                    }
                  });
                }
              )
            }
          },
          returnList(){
            let pm = this.$route.params;
            this.$router.push({name:'task',params:pm});
          },
          loadMore(n) {
            // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
            // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
            return () => (this.rangeNumber += 5); // 每次滚动到底部可以新增条数,可自定义
          },
          //远程搜索方法
          remoteMethod(query) {
            if (query !== '') {
              // 清除之前的定时器
              if (this.timeout) {
                clearTimeout(this.timeout)
              }
              // 防抖处理，300ms后执行
              this.timeout = setTimeout(() => {
                this.fetchUserOptions(query)
              }, 200)
            } else {
              this.TaskOwnerList = []
            }
          },
          fetchUserOptions(query) {
            let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
            this._get(url).then().then(res => {
              if(res.code === 200 && res.data) {
                this.TaskOwnerList = res.data;
              } else {
                this.TaskOwnerList = [];
              }
            }).catch(error => {
              this.TaskOwnerList = [];
              console.error('搜索失败:', error)
            })
          },
          remoteBom(query) {
            if (query !== '') {
              setTimeout(() => {
                this.ServiceBomList = this.SBomList.filter(item => {
                  return item.serviceBom.toLowerCase().indexOf(query.toLowerCase()) > -1;
                });
              }, 200);
            } else {
              this.ServiceBomList = this.SBomList;
            }
          },
          filterUserCode(filterVal){
            if (filterVal) {
              let url =`${this.$store.state.islhurl}user/batch-get`;
              let obj = {
                empCodeList: [filterVal]
              }
              this._post(url, obj).then(
                res => {  
                  if(res.code === 200 && res.data) {
                    this.TaskOwnerList = res.data
                  }
                }
              )
            }
          },
          filterProjectCode(filterVal){
            if(filterVal){
              let filterArr = this.PJList.filter(item => {
                return item.projectNumber.toLowerCase().indexOf(filterVal.toLowerCase()) > -1;
              })
              this.ProjectList = filterArr;
            }else{
              this.ProjectList = this.PJList;
            }
          },
        },
        watch:{
          'taskForm.subcontract'(val,oldval){
            if(this.taskForm.subcontract=='Yes' && (this.taskForm.taskType=='CUSSC' || this.taskForm.taskType=='POCSC')){
              this.taskForm.serviceBom='8814A0Q7';
              this.serviceBomDisabled=true;
            }else if(this.taskForm.subcontract=='Yes' && this.taskForm.taskType=='WDCSC'){
              this.taskForm.serviceBom='8813A4GP';
              this.serviceBomDisabled=true;
            }else{
              this.serviceBomDisabled=false;
            }
          },
          'taskForm.taskType'(val,oldval){
            if(this.taskForm.taskType=='CUSSC' || this.taskForm.taskType=='POCSC'){
              this.taskForm.serviceBom='8814A0Q7';
              this.serviceBomDisabled=true;
              this.taskForm.subcontract="Yes";
            }else if(this.taskForm.taskType=='WDCSC'){
              this.taskForm.serviceBom='8813A4GP';
              this.serviceBomDisabled=true;
              this.taskForm.subcontract="Yes";
            }else{
              this.serviceBomDisabled=false;
              // this.taskForm.serviceBom="";
              this.taskForm.subcontract="No";
            }
          }
        },
        directives:{
          'el-select-loadmore':(el, binding) => {
            // 获取element-ui定义好的scroll盒子
            const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
            if(SELECTWRAP_DOM){
              //解除绑定事件
              el.unbindEventListener = () => {
                SELECTWRAP_DOM.removeEventListener("scroll", function () {
                  const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                  if (condition) binding.value();
                });
              }
              //绑定事件
              SELECTWRAP_DOM.addEventListener("scroll", function () {
                /**
                 * scrollHeight 获取元素内容高度(只读)
                 * scrollTop 获取或者设置元素的偏移值,
                 *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
                 * clientHeight 读取元素的可见高度(只读)
                 * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
                 * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
                 */
                const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                if (condition) binding.value();
              });
            }
          },
        }
    }
</script>


// WEBPACK FOOTER //
// src/view/task/taskEdit.vue